import React, { Dispatch } from 'react';
import { ErrorMessage } from '../utils/errorMessages';
import { CoreApi } from '@inter-ikea-storageone/range';
import { ErrorMessageInlineProps } from './ErrorMessageInline';
import { IntlShape } from 'react-intl';
import { IStorageOneTranslations } from 'contexts/serviceSettings';

const withErrorMessage = (
  getMessage: (
    dispatch: Dispatch<any>,
    coreApi: CoreApi,
    useMetric: boolean,
    formatMessage: IntlShape['formatMessage'],
    translations: IStorageOneTranslations
  ) => ErrorMessage
) => (Component: React.FunctionComponent<ErrorMessageInlineProps>): React.FunctionComponent => (
  props: any
) => <Component {...props} getMessage={getMessage} />;

export default withErrorMessage;
